import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take, all, call, put } from 'redux-saga/effects';
import { urls } from '../../../utils/urls';
import * as api from '../../../utils/api';
import { SET_LOADER } from '../../../components/App/store/actions';
import store from '../../../store/configureStore';
import { fetchEntity } from '../../../store/saga';
import * as operatorActions from './actions';
import { getCookie } from 'utils/cookies';
import { getEnv } from 'utils/utils';
import { showToaster } from 'components/Toaster/action';
import * as Sentry from '@sentry/react';
export function* getOperatorsList(params) {
  const request = api.getOperatorsListRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.getOperatorsList, params);
}

export function* getVehiclesList(params) {
  const request = api.getVehiclesListRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.getVehiclesList, params);
}

export function* updateBasicDetails(payload) {
  const request = api.updateOperatorRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateBasicDetails, payload);
}

export function* createOperatorVehicle(payload) {
  const request = api.createOperatorVehicleRequest.bind(null, payload);

  yield fetchEntity(request, operatorActions.createOperatorVehicleDetails, payload);
}

export function* getOperatorSearch(params) {
  const request = api.operatorSearchRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.getOperatorSearch, params);
}

export function* updateDocuments(payload) {
  const request = api.updateDocumentsRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateDocuments, payload);
}

export function* downloadLedger(params) {
  const request = api.downloadLedgerRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.downloadLedger, params);
}

export function* getFileView(params) {
  const request = api.fileViewRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.getFileView, params);
}

export function* viewTdsFile(payload) {
  const request = api.viewTdsFileRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.viewTdsFile, payload);
}

export function* getFileUpload(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadFile, payload);
    if (response.res.ok) yield put(operatorActions.getFileUpload.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* getRcLink(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadRc, payload);
    if (response.res.ok) yield put(operatorActions.getRcLink.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

function uploadRc(payload) {
  let requestPayload = { ...payload };
  let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  return fetch(
    `${urls.rcUpload}?vehicle-number=${requestPayload.vehicleNumber}&file-name=${requestPayload.fileName}&doc-type=VEHICLE_RC`,
    headers,
  )
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/octet-stream',
            ...headers,
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data.viewUrl, res: resp };
    });
}

export function* getTdsFileUpload(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadTdsFile, payload);
    if (response.res.ok) yield put(operatorActions.getTdsFileUpload.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

function uploadTdsFile(payload) {
  let requestPayload = { ...payload };
  let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  return fetch(
    `${urls.operatorsList}/${requestPayload.id}/tds-declaration/upload-url?reference-time=${requestPayload.referenceTime}`,
    headers,
  )
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type':
              (requestPayload.fileName.includes('.pdf') && 'application/pdf') || 'application/octet-stream',
            ...headers,
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data.name, res: resp };
    });
}

function uploadFile(payload) {
  let requestPayload = { ...payload };
  let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  return fetch(`${urls.uploadOperatorFile}?id=${requestPayload.id}&type=${requestPayload.type}`, headers)
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type':
              (requestPayload.fileName.includes('.pdf') && 'application/pdf') || 'application/octet-stream',
            ...headers,
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data.name, res: resp };
    });
}

export function* operatorType() {
  const request = api.operatorTypeRequest.bind();
  yield fetchEntity(request, operatorActions.operatorType, null);
}

export function* operatorStatus() {
  const request = api.operatorStatusRequest.bind();
  yield fetchEntity(request, operatorActions.operatorStatus, null);
}

export function* getPhoneNo(params) {
  const request = api.phoneNoRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.getPhoneNo, null);
}

export function* settleTrip(payload) {
  const request = api.settleTripRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.settleTrip, payload);
}

export function* getTrips(params) {
  const request = api.getTripsRequest.bind(null, params);
  yield fetchEntity(request, operatorActions.getTrips, params);
}

export function* getBankAccount(opId) {
  const request = api.getBankAccountByOpId.bind(null, opId);
  yield fetchEntity(request, operatorActions.getBankAccount, opId);
}

// export function* updateCompanyDetails(payload) {
//   const request = api.updateCompanyRequest.bind(null, payload);
//   yield fetchEntity(request, operatorActions.updateCompanyDetails, payload);
// }

export function* saveRcLink(payload) {
  const request = api.saveRcUrlRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.saveRcLink, payload);
}

export function* createOperator(payload) {
  const request = api.createOperatorRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.createOperator, payload);
}

export function* createBankAccount(payload) {
  const request = api.createAccountRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.createBankAccount, payload);
}

export function* editBankAccount(payload) {
  const request = api.editAccountRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.editBankAccount, payload);
}

export function* verifyBankAccountOtp(payload) {
  const request = api.verifyExpenseOtpRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.verifyBankAccountOtp, payload);
}

export function* resendBankAccountOtp(payload) {
  const request = api.resendExpenseOtpRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.resendBankAccountOtp, payload);
}

export function* revertOperatorDocument(payload) {
  const request = api.revertOperatorDocumentRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.revertOperatorDocument, payload);
}

export function* verifyRevertDocumentOtp(payload) {
  const request = api.verifyExpenseOtpRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.verifyRevertDocumentOtp, payload);
}

export function* resendRevertDocumentOtp(payload) {
  const request = api.resendExpenseOtpRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.resendRevertDocumentOtp, payload);
}

export function* disableAccount(payload) {
  const request = api.disableEditRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.disableAccount, payload);
}

export function* sendToThirdParty(payload) {
  const request = api.sendToThirdPartyRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.sendToThirdParty, payload);
}

export function* getOperatorById(id) {
  if (!!id) {
    let requests = [
      api.getOperatorByIdRequest.bind(null, id),
      api.getOperatorDocuments.bind(null, id),
      api.companyDetailsRequest.bind(null, id),
      api.tripCountRequest.bind(null, id),
    ];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getOperatorById.success(responses, id));
    } catch (error) {
      Sentry.captureException(error);

      // log error
    }
  }
}
export function* getOperatorKycHistory(id) {
  if (!!id) {
    let requests = [api.getOperatorKycHistory.bind(null, id)];
    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getOperatorKycHistory.success(responses, id));
    } catch (error) {
      Sentry.captureException(error);

      // log error
    }
  }
}
export function* getKycStatusRemarks(currStatus, prevStatus) {
  if (!!currStatus) {
    let requests = [api.getKycStatusRemarks.bind(null, currStatus, prevStatus)];
    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getKycStatusRemarks.success(responses, currStatus));
    } catch (error) {
      Sentry.captureException(error);

      // log error
    }
  }
}
export function* getOperatorByOpCode(opCode) {
  if (!!opCode) {
    let requests = [
      api.getBasicDetailsOperatorRequest.bind(null, opCode),
      api.getAddressDetailsOperatorRequest.bind(null, opCode),
      api.getCompliancesDetailsOperatorRequest.bind(null, opCode),
      api.getDocumentDetailsOperatorRequest.bind(null, opCode),
    ];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getOperatorByOpCode.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      // log error
    }
  }
}
export function* getODVTList(opCode) {
  if (!!opCode) {
    let requests = [api.fetchODVTList.bind(null, opCode)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getODVTList.success(responses[0]?.data?.data, opCode));
    } catch (error) {
      Sentry.captureException(error);

      yield put(operatorActions.getODVTList.failure());
    }
  }
}
export function* updateODVT(payload) {
  try {
    const request = api.updateODVT.bind(null, payload);
    const response = yield call(request);
    if (response.data.success) {
      yield put(operatorActions.postODVT.success(response.data?.data));
      yield put(showToaster({ toasterMsg: response?.data.message, toasterType: 'success' }));
      payload.callbackFunction();
      yield put(operatorActions.getODVTList.request(payload.opCode));
    }
  } catch (error) {
    Sentry.captureException(error);

    yield put(operatorActions.postODVT.failure());
    yield put(showToaster({ toasterMsg: error.message ?? '', toasterType: 'error' }));
  }
}
export function* deleteODVT(params) {
  try {
    const request = api.deleteODVT.bind(null, params.id);
    const response = yield call(request);
    if (response.data.success) {
      yield put(operatorActions.deleteODVT.success(response.data.data));
      yield put(operatorActions.getODVTList.request(params.opCode));
      yield put(showToaster({ toasterMsg: response.data.message, toasterType: 'success' }));
    } else {
      yield put(operatorActions.deleteODVT.failure(response.data.message));
      yield put(showToaster({ toasterMsg: response.data.message, toasterType: 'error' }));
    }
  } catch (error) {
    Sentry.captureException(error);

    yield put(showToaster({ toasterMsg: error.message ?? '', toasterType: 'error' }));
  }
}
export function* addNewODVT(payload) {
  const request = api.addNewODVT.bind(null, payload.params);
  try {
    const response = yield call(request);
    if (response.data.success) {
      yield put(operatorActions.postODVT.success(response.data.data));
      payload.callbackFunction();
      yield put(operatorActions.getODVTList.request(payload.params.opCode));
      yield put(showToaster({ toasterMsg: response.data.message ?? '', toasterType: 'success' }));
    } else {
      yield put(operatorActions.postODVT.failure(response.data.message));
      yield put(showToaster({ toasterMsg: response.data.message, toasterType: 'error' }));
    }
  } catch (error) {
    Sentry.captureException(error);

    yield put(showToaster({ toasterMsg: error.message ?? '', toasterType: 'error' }));
  }
}

export function* searchByVehicleNumber(payload) {
  const request = api.searchVehicleInformation.bind(null, payload.vNum);
  try {
    const response = yield call(request);
    if (response.data.success) {
      yield put(operatorActions.getVehicleInformation.success(response.data.data));
      yield put(showToaster({ toasterMsg: response.data.message ?? '', toasterType: 'success' }));
    } else {
      yield put(showToaster({ toasterMsg: response.data.message, toasterType: 'error' }));
    }
  } catch (error) {
    Sentry.captureException(error);

    yield put(showToaster({ toasterMsg: error?.response?.data?.message ?? '', toasterType: 'error' }));
  }
}
export function* getBasicDetailsOperator(opCode) {
  if (!!opCode) {
    let requests = [api.getBasicDetailsOperatorRequest.bind(null, opCode)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getBasicDetailsOperator.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      //log(error)
    }
  }
}

export function* getAddressDetailsOperator(opCode) {
  if (!!opCode) {
    let requests = [api.getAddressDetailsOperatorRequest.bind(null, opCode)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getAddressDetailsOperator.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      //log(error)
    }
  }
}

export function* getCompliancesDetailsOperator(opCode) {
  if (!!opCode) {
    let requests = [api.getCompliancesDetailsOperatorRequest.bind(null, opCode)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getCompliancesDetailsOperator.success(responses, opCode));
    } catch (error) {
      //log(error)
      Sentry.captureException(error);
    }
  }
}

export function* getDocumentDetailsOperator(opCode) {
  if (!!opCode) {
    let requests = [api.getDocumentDetailsOperatorRequest.bind(null, opCode)];
    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getDocumentDetailsOperator.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      //log(error)
      if (!!error.response.data.message) {
        yield put(showToaster({ toasterMsg: error.response.data.message, toasterType: 'error' }));
      }
    }
  }
}

export function* getVehicleDetailsOperator(opCode) {
  if (!!opCode) {
    let requests = [api.getVehicleDetailsOperatorRequest.bind(null, opCode)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.getVehicleDetailsOperator.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      //log(error)
    }
  }
}

export function* sendUndertakingLink(opCode) {
  if (!!opCode) {
    let requests = [api.sendUnderTakingLinkUrl.bind(null, opCode)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.sendUnderTakingLink.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      yield put(operatorActions.sendUnderTakingLink.failure(error));
    }
  }
}

export function* sendTdsLink(opCode) {
  if (!!opCode) {
    let requests = [api.sendTdsLinkUrl.bind(null, opCode)];
    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      yield put(operatorActions.sendTdsLink.success(responses, opCode));
    } catch (error) {
      Sentry.captureException(error);

      yield put(operatorActions.sendTdsLink.failure(error));
    }
  }
}

export function* viewUploadedDocument(params) {
  if (!!params) {
    let requests = [api.getUploadedDocumentUrlRequest.bind(null, params)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));

      if (responses[0].data.message === 'Ok') {
        window.open(responses[0].data.data.viewUrl, '_blank');
      }

      yield put(operatorActions.viewUploadedDocument.success(responses, params));
    } catch (error) {
      Sentry.captureException(error);

      //log(error)
    }
  }
}

// export function* getFileUpload(payload) {
//   try {
//     store.dispatch({ type: SET_LOADER });
//     const response = yield call(uploadFile, payload);
//      (rifesponse.res.ok) yield put(operatorActions.getFileUpload.success(response.resp, payload));
//   } catch (err) {
//     console.log(err);
//   } finally {
//     store.dispatch({ type: SET_LOADER });
//   }
// }

export function* uploadOperatorIdentityDocument(payload) {
  const formData = {
    fileName: payload.fileName.name,
    docType: payload.docType,
  };

  let requests = [api.uploadOperatorIdentityDocumentRequest.bind(null, formData)];

  try {
    store.dispatch({ type: SET_LOADER });
    const responses = yield all(requests.map((fn) => call(fn)));

    if (responses[0].data.message === 'Ok')
      yield put(operatorActions.uploadOperatorIdentityDocument.success(responses, payload));
    let imgResourceKey = responses[0].data.data.imgResourceKey;
    let resKey = {
      payload: imgResourceKey,
      // typeImg: action.typeImg,
    };

    const uploadUrl = responses[0].data.data.imgUrl;
    let requestURL2 = uploadUrl.toString();

    if (responses) {
      fetch(` ${requestURL2}`, {
        headers: { Accept: 'application/json, text/plain, /' },
        method: 'PUT',
        body: payload.fileName,
      })
        .then((response) => {
          // console.log(response);
        })
        //Then with the data from the response in JSON...
        .then((data) => {})
        .catch((error) => {
          Sentry.captureException(error);

          console.error('Error:', error);
        });
    }

    //   if (response.res.ok) yield put(operatorActions.uploadOperatorIdentityDocument.success(response.resp, payload));
  } catch (err) {
    Sentry.captureException(err);

    //   console.log(err);
    // } finally {
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

function uploadOperatorIdentity(payload) {
  let requestPayload = { ...payload };

  // let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  return (
    fetch(`${urls.operatorBasicDetails}/add-documents`, {
      headers: { Accept: 'application/json, text/plain, /' },
      method: 'PUT',
      body: payload,
    })
      .then((response) => response.json())
      .then(([response, resp]) => {
        return { resp: response.data.name, res: resp };
      })
      // .then(([response, resp]) => {
      //   return { resp: response.data.name, res: resp };
      // });
      .catch((error) => {
        Sentry.captureException(error);

        console.error('Error:', error);
      })
  );
}

export function* updateOperatorBasicDetails(payload) {
  const request = api.updateOperatorBasicDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateOperatorBasicDetails, payload);
}

export function* updateOperatorAddressDetails(payload) {
  const request = api.updateOperatorAddressDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateOperatorAddressDetails, payload);
}

export function* updateOperatorComplaincesDetails(payload) {
  const request = api.updateOperatorComplaincesDetailsUrl.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateOperatorComplaincesDetails, payload);
}
export function* updateOperatorVehiclesDetails(payload) {
  const request = api.updateOperatorVehiclesDetailsUrl.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateOperatorVehiclesDetails, payload);
}

export function* updateOperatorDocumentDetails(payload) {
  const request = api.updateOperatorDocumentDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateOperatorDocumentDetails, payload);
}

export function* updateOperatorTdsDetails(payload) {
  const request = api.updateOperatorTdsDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.updateOperatorTdsDetails, payload);
}
// export function* addTdsDeclaration(payload) {
//   const request = api.addTdsDeclarationRequest.bind(null, payload);
//   yield fetchEntity(request, operatorActions.addTdsDeclaration, payload);
// }

// export function* editTdsDeclaration(payload) {
//   const request = api.editTdsDeclarationRequest.bind(null, payload);
//   yield fetchEntity(request, operatorActions.editTdsDeclaration, payload);
// }

export function* getLanesOptions() {
  const request = api.getLanesOptionsRequest.bind();
  yield fetchEntity(request, operatorActions.getLanesOptions, null);
}

export function* editOnboardingDetails(payload) {
  const request = api.editOnboardingDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operatorActions.editOnboardingDetails, payload);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetOperatorsListSaga() {
  while (true) {
    const { params } = yield take(operatorActions.GET_OPERATORS_LIST[REQUEST]);
    yield fork(getOperatorsList, params);
  }
}

export function* watchGetOperatorByIdSaga() {
  while (true) {
    const { id } = yield take(operatorActions.GET_OPERATOR_BY_ID[REQUEST]);
    yield fork(getOperatorById, id);
  }
}

export function* watchGetKycStatusHistorySaga() {
  while (true) {
    const { id } = yield take(operatorActions.GET_KYC_HISTORY[REQUEST]);
    yield fork(getOperatorKycHistory, id);
  }
}
export function* watchGetKycStatusRemarksSaga() {
  while (true) {
    const { currStatus, prevStatus } = yield take(operatorActions.GET_KYC_STATUS_REMARKS[REQUEST]);
    yield fork(getKycStatusRemarks, currStatus, prevStatus);
  }
}

export function* watchGetOperatorByOpCodeSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_OPERATOR_BY_OPCODE[REQUEST]);
    yield fork(getOperatorByOpCode, opCode);
  }
}
export function* watchGetODVTListSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_ODVT_LIST[REQUEST]);
    yield fork(getODVTList, opCode);
  }
}
export function* watchUpdateODVTSaga() {
  while (true) {
    const { params } = yield take(operatorActions.PATCH_ODVT[REQUEST]);
    yield fork(updateODVT, params);
  }
}
export function* watchDeleteODVTSaga() {
  while (true) {
    const { params } = yield take(operatorActions.DELETE_ODVT[REQUEST]);
    yield fork(deleteODVT, params);
  }
}
export function* watchAddNewODVTSaga() {
  while (true) {
    const { params } = yield take(operatorActions.POST_ODVT[REQUEST]);
    yield fork(addNewODVT, params);
  }
}
export function* watchGetVehicleInformationByVehicleNum() {
  while (true) {
    const { params } = yield take(operatorActions.GET_VEHICLE_INFO[REQUEST]);
    yield fork(searchByVehicleNumber, params);
  }
}

export function* watchGetBasicDetailsOperatorSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_BASIC_DETAILS_OPERATOR[REQUEST]);
    yield fork(getBasicDetailsOperator, opCode);
  }
}

export function* watchGetAddressDetailsOperatorSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_ADDRESS_DETAILS_OPERATOR[REQUEST]);
    yield fork(getAddressDetailsOperator, opCode);
  }
}

export function* watchGetCompliancesDetailsOperatorSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_COMPLIANCES_DETAILS_OPERATOR[REQUEST]);
    yield fork(getCompliancesDetailsOperator, opCode);
  }
}

export function* watchGetDocumentDetailsOperatorSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_DOCUMENT_DETAILS_OPERATOR[REQUEST]);

    yield fork(getDocumentDetailsOperator, opCode);
  }
}

export function* watchGetVehicleDetailsOperatorSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.GET_VEHICLE_DETAILS_OPERATOR[REQUEST]);

    yield fork(getVehicleDetailsOperator, opCode);
  }
}

export function* watchViewUploadedDocumentSaga() {
  while (true) {
    const { params } = yield take(operatorActions.VIEW_UPLOADED_DOCUMENT[REQUEST]);
    yield fork(viewUploadedDocument, params);
  }
}

export function* watchSendUndertakingLinkSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.SEND_UNDERTAKING_LINK[REQUEST]);
    yield fork(sendUndertakingLink, opCode);
  }
}

export function* watchSendTdsLinkSaga() {
  while (true) {
    const { opCode } = yield take(operatorActions.SEND_TDS_LINK[REQUEST]);
    yield fork(sendTdsLink, opCode);
  }
}

export function* watchOperatorTypeSaga() {
  while (true) {
    yield take(operatorActions.GET_OPERATOR_TYPE[REQUEST]);
    yield fork(operatorType);
  }
}

export function* watchOperatorStatusSaga() {
  while (true) {
    yield take(operatorActions.GET_OPERATOR_STATUS[REQUEST]);
    yield fork(operatorStatus);
  }
}

export function* watchGetPhoneNoSaga() {
  while (true) {
    const { params } = yield take(operatorActions.GET_PHONE_NO[REQUEST]);
    yield fork(getPhoneNo, params);
  }
}

export function* watchGetBankAccountSaga() {
  while (true) {
    const { opId } = yield take(operatorActions.GET_BANK_ACCOUNT[REQUEST]);
    yield fork(getBankAccount, opId);
  }
}

export function* watchGetRcLinkSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.GET_RC_LINK[REQUEST]);
    yield fork(getRcLink, payload);
  }
}

export function* watchUpdateBasicDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_BASIC_DETAILS[REQUEST]);
    yield fork(updateBasicDetails, payload);
  }
}

export function* watchCreateOperatorVehicleSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.CREATE_OPERATOR_VEHICLE[REQUEST]);
    yield fork(createOperatorVehicle, payload);
  }
}

export function* watchGetOperatorSearch() {
  while (true) {
    const { params } = yield take(operatorActions.GET_OPERATOR_SEARCH[REQUEST]);
    yield fork(getOperatorSearch, params);
  }
}

export function* watchGetVehiclesListSaga() {
  while (true) {
    const { params } = yield take(operatorActions.GET_VEHICLES_LIST[REQUEST]);
    yield fork(getVehiclesList, params);
  }
}

export function* watchUpdateDocuments() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_DOCUMENTS[REQUEST]);
    yield fork(updateDocuments, payload);
  }
}

// export function* watchUpdateCompanyDetailsSaga() {
//   while (true) {
//     const { payload } = yield take(operatorActions.UPDATE_COMPANY_DETAILS[REQUEST]);
//     yield fork(updateCompanyDetails, payload);
//   }
// }

export function* watchUpdateOperatorBasicDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_OPERATOR_BASIC_DETAILS[REQUEST]);
    yield fork(updateOperatorBasicDetails, payload);
  }
}

export function* watchUpdateOperatorAddressDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_OPERATOR_ADDRESS_DETAILS[REQUEST]);

    yield fork(updateOperatorAddressDetails, payload);
  }
}

export function* watchUpdateOperatorComplaincesDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_OPERATOR_COMPLAINCES_DETAILS[REQUEST]);
    yield fork(updateOperatorComplaincesDetails, payload);
  }
}

export function* watchUpdateOperatorVehiclesDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_OPERATOR_VEHICLES_DETAILS[REQUEST]);

    yield fork(updateOperatorVehiclesDetails, payload);
  }
}

export function* watchUpdateOperatorDocumentDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_OPERATOR_DOCUMENT_DETAILS[REQUEST]);
    yield fork(updateOperatorDocumentDetails, payload);
  }
}

export function* watchUpdateOperatorTdsDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPDATE_OPERATOR_TDS_DETAILS[REQUEST]);
    yield fork(updateOperatorTdsDetails, payload);
  }
}

export function* watchUploadOperatorIdentityDocumentSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.UPLOAD_OPERATOR_IDENTITY_DOCUMENTS[REQUEST]);

    yield fork(uploadOperatorIdentityDocument, payload);
  }
}
export function* watchCreateOperatorSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.CREATE_OPERATOR[REQUEST]);
    yield fork(createOperator, payload);
  }
}

export function* watchCreateBankAccountSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.CREATE_BANK_ACCOUNT[REQUEST]);
    yield fork(createBankAccount, payload);
  }
}

export function* watchEditBankAccountSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.EDIT_BANK_ACCOUNT[REQUEST]);
    yield fork(editBankAccount, payload);
  }
}

export function* watchVerifyBankAccountOtpSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.VERIFY_BANK_ACCOUNT_OTP[REQUEST]);
    yield fork(verifyBankAccountOtp, payload);
  }
}

export function* watchResendBankAccountOtpSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.RESEND_BANK_ACCOUNT_OTP[REQUEST]);
    yield fork(resendBankAccountOtp, payload);
  }
}

export function* watchRevertOperatorDocumentSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.REVERT_OPERATOR_DOCUMENT[REQUEST]);
    yield fork(revertOperatorDocument, payload);
  }
}

export function* watchVerifyRevertDocumentOtpSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.VERIFY_REVERT_DOCUMENT_OTP[REQUEST]);
    yield fork(verifyRevertDocumentOtp, payload);
  }
}

export function* watchResendRevertDocumentOtpSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.RESEND_REVERT_DOCUMENT_OTP[REQUEST]);
    yield fork(resendRevertDocumentOtp, payload);
  }
}

export function* watchDisableAccountSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.DISABLE_ACCOUNT[REQUEST]);
    yield fork(disableAccount, payload);
  }
}

export function* watchSendToThirdPartySaga() {
  while (true) {
    const { payload } = yield take(operatorActions.SEND_TO_THIRD_PARTY[REQUEST]);
    yield fork(sendToThirdParty, payload);
  }
}

export function* watchSettleTripSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.SETTLE_TRIP[REQUEST]);
    yield fork(settleTrip, payload);
  }
}

export function* watchGetTripsSaga() {
  while (true) {
    const { params } = yield take(operatorActions.GET_TRIPS[REQUEST]);
    yield fork(getTrips, params);
  }
}

export function* watchDownloadLedgerSaga() {
  while (true) {
    const { params } = yield take(operatorActions.DOWNLOAD_LEDGER[REQUEST]);
    yield fork(downloadLedger, params);
  }
}

export function* watchGetFileUploadSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.GET_FILE_UPLOAD[REQUEST]);
    yield fork(getFileUpload, payload);
  }
}

export function* watchGetFileViewSaga() {
  while (true) {
    const { params } = yield take(operatorActions.GET_FILE_VIEW[REQUEST]);
    yield fork(getFileView, params);
  }
}

export function* watchViewTdsFileSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.GET_TDS_VIEW_URL[REQUEST]);
    yield fork(viewTdsFile, payload);
  }
}

export function* watchSaveRcLinkSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.SAVE_RC_LINK[REQUEST]);
    yield fork(saveRcLink, payload);
  }
}

export function* watchGetTdsFileUploadSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.GET_TDS_FILE_UPLOAD[REQUEST]);
    yield fork(getTdsFileUpload, payload);
  }
}

// export function* watchAddTdsDeclarationSaga() {
//   while (true) {
//     const { payload } = yield take(operatorActions.ADD_TDS_DEC[REQUEST]);
//     yield fork(addTdsDeclaration, payload);
//   }
// }

// export function* watchEditTdsDeclarationSaga() {
//   while (true) {
//     const { payload } = yield take(operatorActions.EDIT_TDS_DEC[REQUEST]);
//     yield fork(editTdsDeclaration, payload);
//   }
// }

export function* watchGetLanesOptionsSaga() {
  while (true) {
    yield take(operatorActions.GET_LANES_OPTIONS[REQUEST]);
    yield fork(getLanesOptions);
  }
}

export function* watchEditOnboardingDetailsSaga() {
  while (true) {
    const { payload } = yield take(operatorActions.EDIT_ONBOARDING_DEATILS[REQUEST]);
    yield fork(editOnboardingDetails, payload);
  }
}
